<div class="search-dialog-container">
  <!-- Vista de búsqueda -->
  <div *ngIf="!mostrarDetalles" class="search-view">
    <div class="dialog-header">
      <h2 class="dialog-title">
        <mat-icon>search</mat-icon>
        Buscar Producto
      </h2>
    </div>

    <mat-dialog-content class="search-content">
      <form [formGroup]="busquedaForm">
        <mat-form-field appearance="outline" class="full-width search-field">
          <mat-label>Código o Nombre</mat-label>
          <input matInput formControlName="busqueda" placeholder="Escriba para buscar..."
                 (keyup.enter)="manejarTeclaBusqueda($event)"
                 autocomplete="off">
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>

        <!-- Lista de sugerencias -->
        <div *ngIf="mostrarSugerencias" class="sugerencias-container">
          <div *ngIf="buscando" class="loading-state">
            <mat-spinner diameter="32"></mat-spinner>
            <p>Buscando productos...</p>
          </div>

          <div *ngIf="!buscando" class="productos-list">
            <div *ngFor="let producto of productosEncontrados"
                 [class.out-of-stock]="producto.stock <= 0"
                 (click)="seleccionarProducto(producto)"
                 class="producto-item">
              <div class="producto-info">
                <div class="producto-header">
                  <span class="producto-codigo">{{ producto.codigo }}</span>
                  <span class="producto-precio">{{ getPrecioFormateado(producto.precio) }}</span>
                </div>
                <h3 class="producto-nombre">{{ producto.nombre }}</h3>
                <div class="producto-meta">
                  <span class="stock-badge" [class.in-stock]="producto.stock > 0" [class.out-stock]="producto.stock <= 0">
                    <mat-icon>{{ producto.stock > 0 ? 'check_circle' : 'cancel' }}</mat-icon>
                    {{ producto.stock > 0 ? 'Stock: ' + producto.stock : 'Sin stock' }}
                  </span>
                  <span *ngIf="producto.peso" class="peso-info">
                    <mat-icon>straighten</mat-icon>
                    {{ producto.peso }}{{ producto.unidadMedida }}
                  </span>
                </div>
              </div>
              <mat-icon class="arrow-icon">chevron_right</mat-icon>
            </div>

            <div *ngIf="productosEncontrados.length === 0 && busquedaForm.get('busqueda')?.value.length >= 2" class="no-results">
              <mat-icon>search_off</mat-icon>
              <p>No se encontraron productos</p>
            </div>
          </div>
        </div>
      </form>
    </mat-dialog-content>
  </div>

  <!-- Vista de detalles del producto -->
  <div *ngIf="mostrarDetalles && productoSeleccionado" class="detail-view">
    <div class="dialog-header">
      <button mat-icon-button (click)="volverABusqueda()" class="back-button">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <h2 class="dialog-title">Detalles del Producto</h2>
      <button mat-icon-button (click)="cerrar()" class="close-button">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <mat-dialog-content class="detail-content">
      <div class="product-detail-card">
        <!-- Header del producto -->
        <div class="product-header">
          <div class="product-title-section">
            <h1 class="product-name">{{ productoSeleccionado.nombre }}</h1>
            <div class="product-meta-row">
              <span class="meta-item">
                <mat-icon>qr_code</mat-icon>
                {{ productoSeleccionado.codigo }}
              </span>
              <span class="meta-item price">
                <mat-icon>attach_money</mat-icon>
                {{ getPrecioFormateado(productoSeleccionado.precio) }}
              </span>
              <span class="meta-item stock" [class.low]="productoSeleccionado.stock <= 0">
                <mat-icon>{{ productoSeleccionado.stock > 0 ? 'inventory' : 'inventory_2' }}</mat-icon>
                Stock: {{ productoSeleccionado.stock }}
              </span>
            </div>
          </div>
        </div>

        <div class="divider"></div>

        <!-- Información del producto -->
        <div class="product-info-grid">
          <!-- Peso -->
          <div *ngIf="productoSeleccionado.peso" class="info-card">
            <div class="info-icon">
              <mat-icon>straighten</mat-icon>
            </div>
            <div class="info-content">
              <h4>Peso</h4>
              <p>{{ productoSeleccionado.peso }}{{ productoSeleccionado.unidadMedida || '' }}</p>
            </div>
          </div>

          <!-- Descripción -->
          <div *ngIf="tieneContenido(productoSeleccionado.descripcion)" class="info-card full-width">
            <div class="info-icon">
              <mat-icon>description</mat-icon>
            </div>
            <div class="info-content">
              <h4>Descripción</h4>
              <p>{{ productoSeleccionado.descripcion }}</p>
            </div>
          </div>

          <!-- Ingredientes -->
          <div *ngIf="productoSeleccionado.ingredientes && productoSeleccionado.ingredientes.length > 0" class="info-card full-width">
            <div class="info-icon">
              <mat-icon>list</mat-icon>
            </div>
            <div class="info-content">
              <h4>Ingredientes</h4>
              <p>{{ getIngredientes(productoSeleccionado.ingredientes) }}</p>
            </div>
          </div>

          <!-- Beneficios -->
          <div *ngIf="tieneContenido(productoSeleccionado.beneficios)" class="info-card full-width">
            <div class="info-icon">
              <mat-icon>favorite</mat-icon>
            </div>
            <div class="info-content">
              <h4>Beneficios</h4>
              <p>{{ productoSeleccionado.beneficios }}</p>
            </div>
          </div>

          <!-- Modo de Uso -->
          <div *ngIf="tieneContenido(productoSeleccionado.modoUso)" class="info-card full-width">
            <div class="info-icon">
              <mat-icon>info</mat-icon>
            </div>
            <div class="info-content">
              <h4>Modo de Uso</h4>
              <p>{{ productoSeleccionado.modoUso }}</p>
            </div>
          </div>

          <!-- Condiciones de Almacenamiento -->
          <div *ngIf="tieneContenido(productoSeleccionado.condicionesAlmacenamiento)" class="info-card full-width">
            <div class="info-icon">
              <mat-icon>storage</mat-icon>
            </div>
            <div class="info-content">
              <h4>Condiciones de Almacenamiento</h4>
              <p>{{ productoSeleccionado.condicionesAlmacenamiento }}</p>
            </div>
          </div>

          <!-- Etiquetas -->
          <div *ngIf="productoSeleccionado.etiquetas && productoSeleccionado.etiquetas.length > 0" class="info-card full-width">
            <div class="info-icon">
              <mat-icon>label</mat-icon>
            </div>
            <div class="info-content">
              <h4>Etiquetas</h4>
              <div class="tags-container">
                <span *ngFor="let etiqueta of productoSeleccionado.etiquetas" class="tag-chip">
                  {{ etiqueta }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-dialog-content>
  </div>

  <mat-dialog-actions *ngIf="!mostrarDetalles" align="end" class="dialog-actions">
    <button mat-button (click)="cerrar()">Cerrar</button>
  </mat-dialog-actions>
</div>

